import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as toast from "../roots_Comp/Components/Toaster/ToastReducer";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  toast : toast.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
